import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { AuthResult } from '../../core/models/auth.models';
import { SupportLoginService } from '../../features/profile/support-login/support-login.service';
import { CommonService } from '../../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NzLayoutModule,
    SidebarComponent,
    HeaderComponent,
    CommonModule,
    NzButtonModule,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  isSupportLogin = false;
  supportUserData: AuthResult | null = null;

  constructor(
    private supportLoginSrv: SupportLoginService,
    private router: Router,
    private commonService: CommonService
  ) {
    this.supportLoginSrv.supportUserData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.supportUserData = data;
      });
  }

  supportUserLogOut() {
    this.supportLoginSrv
      .supportLogout()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.router
            .navigateByUrl('/activity-dashboard', { replaceUrl: true })
            .then(() => {
              setTimeout(() => {
                window.location.reload();
              }, 50);
            });
        },
        error: (error: Error) => {
          console.error('Support logout error:', error);
          this.commonService.notify('error', error.message);
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
